import { apiFetch } from '../httpClient';

const NOTIFICATION_SETTINGS_ENDPOINT =
  process.env.REACT_APP_NOTIFICATION_SETTINGS_ENDPOINT ||
  '/api/users/me/notification-settings';
const NOTIFICATION_SETTINGS_UPDATE_METHOD =
  process.env.REACT_APP_NOTIFICATION_SETTINGS_UPDATE_METHOD || 'PATCH';

// 로그인 사용자의 알림 설정을 조회한다.
export async function fetchMyNotificationSettings() {
  return apiFetch(NOTIFICATION_SETTINGS_ENDPOINT, {
    method: 'GET',
  });
}

// 로그인 사용자의 알림 설정을 저장한다.
export async function updateMyNotificationSettings(settingsPayload) {
  return apiFetch(NOTIFICATION_SETTINGS_ENDPOINT, {
    method: NOTIFICATION_SETTINGS_UPDATE_METHOD,
    body: settingsPayload,
  });
}

